module.exports = __webpack_public_path__ + "assets/security-5-f3bc379a9f66d128f324685e452b3a0d.svg";